import React from 'react'

import { AppFuelPolicyAutocomplete } from '@components/Autocomplete'
import { fuelPolicy } from '@signals'
import { BACKEND_APIS } from '@constants'


export default function FuelPolicyAutocomplete({ ...props }) {
	return <AppFuelPolicyAutocomplete
		value={fuelPolicy.value}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/fuel_policy`}
		onChange={e => fuelPolicy.value = e.target.value}
		{...props}
	/>
}